module.exports = __webpack_public_path__ + "img/2025-0411-01-01.e1fa7440.png";